import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleInfo,
  faTriangleExclamation,
  faCircleCheck,
  faCircleXmark,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

const TONE_MAP = {
  info: faCircleInfo,
  warning: faTriangleExclamation,
  success: faCircleCheck,
  error: faCircleXmark,
};

const AdminNotice = ({ tone = 'info', title, message, onDismiss, autoDismissMs }) => {
  useEffect(() => {
    if (!autoDismissMs || !onDismiss) {
      return undefined;
    }

    const timer = window.setTimeout(onDismiss, autoDismissMs);
    return () => window.clearTimeout(timer);
  }, [autoDismissMs, onDismiss]);

  const icon = TONE_MAP[tone] || TONE_MAP.info;

  return (
    <div className={`admin-notice admin-notice-${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      <FontAwesomeIcon icon={icon} className="admin-notice-icon" />
      <div className="admin-notice-content">
        {title ? <div className="admin-notice-title">{title}</div> : null}
        <div className="admin-notice-message">{message}</div>
      </div>
      {onDismiss ? (
        <button type="button" className="admin-notice-dismiss" onClick={onDismiss} aria-label="Bildirimi kapat">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      ) : null}
    </div>
  );
};

export default AdminNotice;
